import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, InputGroup, Input } from 'reactstrap';
import useUsuarios from '../../../hooks/useUsuarios';
import Select from 'react-select';
import Swal from "sweetalert2";

const Roles = [
    { value: "super administrador", label: "Super administrador" },
    { value: "administrador", label: "Administrador" },
    { value: "contabilidad", label: "Contabilidad" },
    { value: "cliente", label: "Cliente" },
    { value: "proveedor", label: "Proveedor" },
];

const Estatus = [
    { value: "Activo", label: "Activo" },
    { value: "Cancelado", label: "Cancelado" }
];

export default function ModalAdd({
    modal,
    toggle,
    Nombre,
    Correo,
    Rol,
    Status,
    Update,
    Id,
    token,
    setNombre,
    setCorreo,
    setRol,
    setStatus,
    UsuariosGetService }) {

    const { loading, message, error, success, UsuariosAddService, UsuariosUpdateService } = useUsuarios();
    const [SelectedStatus, setSelectedStatus] = useState([]);
    const [SelectedRol, setSelectedRol] = useState([]);
    const [Password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if (success === true) {
            UsuariosGetService(token)
        }
    }, [UsuariosGetService, success])

    useEffect(() => {
        if (!modal) {
            setPassword("");
            setShowPassword(false);
        }
    }, [modal])

    const createUser = () => {
        if (!Nombre || !Correo || !Rol || !Status) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Completa todos los campos",
            });
            return;
        }

        if (!Update && !Password) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "La contraseña es obligatoria",
            });
            return;
        }

        if (Update) {
            const data = new FormData();
            data.append("id", Id);
            data.append("name", Nombre);
            data.append("email", Correo);
            data.append("rol", Rol);
            data.append("status", Status);

            UsuariosUpdateService(data, token);

            Swal.fire({
                title: "Actualizando usuario",
                text: "Loading...",
                allowEscapeKey: false,
                allowOutsideClick: false,
                showConfirmButton: false,
                icon: 'question',
                onOpen: () => {
                    Swal.showLoading();
                }
            });

        } else {
            const data = new FormData();
            data.append("name", Nombre);
            data.append("email", Correo);
            data.append("rol", Rol);
            data.append("status", Status);
            data.append("password", Password);

            UsuariosAddService(data, token);

            Swal.fire({
                title: "Registrando usuario",
                text: "Loading...",
                allowEscapeKey: false,
                allowOutsideClick: false,
                showConfirmButton: false,
                icon: 'question',
                onOpen: () => {
                    Swal.showLoading();
                }
            });
        }
    }

    useEffect(() => {
        if (error) {
            Swal.close();
            Swal.fire({
                icon: "error",
                title: "Error",
                confirmButtonColor: "#3b82f6",
                text: message,
            });
        }
    }, [message, error])

    useEffect(() => {
        if (success) {
            Swal.close();
            Swal.fire({
                icon: "success",
                title: "Exito",
                confirmButtonColor: "#3b82f6",
                text: message,
            });
            setNombre('');
            setCorreo('');
            setRol('');
            setSelectedRol([]);
            setPassword('');
            toggle();
        }
    }, [message, success])

    return <>
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className="backend_titulo" toggle={toggle}>{Update ? "Editar usuario" : "Agregar usuario"}</ModalHeader>
            <ModalBody>
                <div className="crud-modal-field">
                    <label className="crud-modal-label">Nombre</label>
                    <Input placeholder="Nombre" value={Nombre} onChange={e => setNombre(e.target.value)} />
                </div>
                <div className="crud-modal-field">
                    <label className="crud-modal-label">Correo electrónico</label>
                    <Input type='email' placeholder="Correo" value={Correo} onChange={e => setCorreo(e.target.value)} />
                </div>
                {!Update && (
                    <div className="crud-modal-field">
                        <label className="crud-modal-label">Contraseña</label>
                        <div className="crud-password-wrap">
                            <Input
                                type={showPassword ? "text" : "password"}
                                placeholder="Contraseña"
                                value={Password}
                                onChange={e => setPassword(e.target.value)}
                            />
                            <button
                                type="button"
                                className="crud-password-toggle"
                                onClick={() => setShowPassword(!showPassword)}
                                aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                            >
                                <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                            </button>
                        </div>
                    </div>
                )}
                <div className="crud-modal-field">
                    <label className="crud-modal-label">Rol</label>
                    <Select
                        value={SelectedRol}
                        onChange={(e) => {
                            setRol(e.value);
                            setSelectedRol(e)
                        }}
                        options={Roles}
                        placeholder={Rol ? Rol : "Roles"}
                    />
                </div>
                <div className="crud-modal-field">
                    <label className="crud-modal-label">Estatus</label>
                    <Select
                        value={SelectedStatus}
                        onChange={(e) => {
                            setStatus(e.value);
                            setSelectedStatus(e)
                        }}
                        options={Estatus}
                        placeholder={Status ? Status : "Status"}
                    />
                </div>
            </ModalBody>
            <ModalFooter>
                <Button className="backend_boton" onClick={(() => createUser())}>{Update ? "Guardar cambios" : "Agregar"}</Button>{' '}
            </ModalFooter>
        </Modal>
    </>
}
